import React from 'react';
import Spin from 'components/Spin';
import { useLoadingSpinData } from './selectorData';

const LoadingSpin = ({ children }) => {
  const { detailLoading, DOTClassificationsLoading } = useLoadingSpinData();

  return (
    <Spin
      spinning={detailLoading || DOTClassificationsLoading}
      tip={'Loading...'}
    >
      {children}
    </Spin>
  );
};

export default LoadingSpin;
